import React, { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import _ from 'lodash';

import Form, { FormEditorProps, useForm } from 'src/presentation/components/forms/Form';
import mobileNumberIdentificationConfigResource from 'src/actions/mobileNumberIdentification/mobileNumberIdentificationConfigResource';
import { DetailedSwitch } from '../../forms/DetailedSwitch';

const MobileNumberIdentificationForm: FC<FormEditorProps> = ({ item, errors, root }) => {
  const resetErrors = mobileNumberIdentificationConfigResource.actions.resetErrors;
  const update = mobileNumberIdentificationConfigResource.effects.replace;
  const learnMoreLink = (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://help.gladly.com/implementation/docs/invoice-and-billing-overview#telephony-platform-invoices"
    >
      Learn more.
    </a>
  );
  const enabledMobileNumberIdNode = (
    <>
      <span>
        Turning off Mobile Phone Number Identification will impact your Gladly capabilities and monthly telephony bill.{' '}
      </span>
      {learnMoreLink}
    </>
  );
  const disabledMobileNumberIdNode = (
    <>
      <span>Turning on Mobile Phone Number Identification will impact your monthly telephony bill. </span>
      {learnMoreLink}
    </>
  );
  const formContext = useForm({
    item,
    errors,
    resetErrors,
    root,
    update,
  });

  const { workingState, updateState } = formContext;

  const dispatch = useDispatch();

  const toggleEnabled = useCallback(
    value => {
      dispatch(resetErrors({}));
      dispatch(
        update(
          {},
          { enabled: value },
          { successToastMessage: `Mobile Phone Number Identification is now ${value ? 'on' : 'off'}` }
        )
      );
      updateState({ enabled: value });
    },
    [dispatch, resetErrors, update, updateState]
  );

  const switchHeading = (
    <>Mobile Phone Number Identification is turned {_.get(workingState, 'enabled') ? 'on' : 'off'}</>
  );

  return (
    <Form context={formContext}>
      <FormContainer>
        <DetailedSwitch
          attr="enabled"
          conditionalText
          data-aid="admin-mobile-number-identification-switch"
          disabledText={disabledMobileNumberIdNode}
          enabledText={enabledMobileNumberIdNode}
          onChange={toggleEnabled}
          switchHeading={switchHeading}
        />
      </FormContainer>
    </Form>
  );
};

export default MobileNumberIdentificationForm;

const FormContainer = styled.div`
  padding-left: 24px;
`;
